(() => {
  const BRANDS = {
    acento: [
      'Acento',
      'Style Selections',
      'Moorefield',
      'Sheffield Labs',
      'Empire Lighting',
      '15 West'
    ],
    decor: [
      'Decor Living',
      'Flowell',
      'Sheffield Home',
      'Park Place',
      'Artia',
      'Oaside'
    ]
  };

  const BRAND_ALIASES = {
    'Acento': ['Style Selections']
  };

  const COLLECTION_FILTERS = {  };

  const COUNTRY_KEY = 'enchliving:last-country';
  const LANGUAGE_KEY = 'enchliving:last-language';
  const FILTERS_KEY = 'enchliving:saved-filters';
  const CATALOG_STORAGE_KEY = 'enchliving:online-store-only';
  const CATALOG_BODY_CLASS = 'enchliving-online-store-only';

  const match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
  if (!match) return;

  const config = COLLECTION_FILTERS[match[1]];
  const metafieldConfig = window.__collectionFilter;
  if (!config && !metafieldConfig) return;

  const loc = window.__enchlivingLocation || {};
  const currentCountry = (loc.country || '').toString().toUpperCase();
  const currentLanguage = (loc.language || document.documentElement.lang || 'en').toString().toLowerCase();
  const countryCode = currentCountry.toLowerCase();

  const resolveBrands = ({ store, brands, exclude }) => {
    let list = [];
    if (store && BRANDS[store]) list = [...BRANDS[store]];
    if (brands) list = [...list, ...brands];
    // Incluir vendors operativos que deben mostrarse bajo la misma marca comercial.
    list = list.flatMap(brand => [brand, ...(BRAND_ALIASES[brand] || [])]);
    if (exclude) list = list.filter(b => !exclude.includes(b));
    return [...new Set(list)];
  };

  const normalizeCatalogMode = (mode) => {
    if (mode === true) return 'online_store';
    if (mode === false) return 'full_catalog';
    if (typeof mode !== 'string') return 'keep';

    const value = mode.trim().toLowerCase();

    if (value === 'online' || value === 'online_store') return 'online_store';
    if (value === 'all' || value === 'full_catalog') return 'full_catalog';

    return 'keep';
  };

  const resolveCatalogMode = (catalog) => {
    if (!catalog) return 'keep';
    if (typeof catalog === 'string' || typeof catalog === 'boolean') {
      return normalizeCatalogMode(catalog);
    }

    const countryMode = normalizeCatalogMode(catalog[countryCode]);
    if (countryMode !== 'keep') return countryMode;

    return normalizeCatalogMode(catalog.default);
  };

  const applyCatalogMode = (mode) => {
    const normalizedMode = normalizeCatalogMode(mode);
    if (normalizedMode === 'keep') return;

    const onlineStoreOnly = normalizedMode === 'online_store';

    try {
      localStorage.setItem(CATALOG_STORAGE_KEY, onlineStoreOnly ? '1' : '0');
    } catch (e) {
    }

    if (document.body) {
      document.body.classList.toggle(CATALOG_BODY_CLASS, onlineStoreOnly);
    }
  };

  const metafieldOverrides = Object.fromEntries(
    Object.entries(metafieldConfig || {}).filter(([, value]) => value !== null && value !== undefined && value !== '')
  );

  const finalConfig = {
    ...(config || {}),
    ...metafieldOverrides
  };

  const vendors = resolveBrands(finalConfig);
  const catalogMode = resolveCatalogMode(finalConfig.catalog || {
    default: finalConfig.catalogDefault,
    us: finalConfig.catalogUs,
    ca: finalConfig.catalogCa,
    mx: finalConfig.catalogMx
  });

  const url = new URL(window.location);

  let countryChanged = false;
  let languageChanged = false;

  applyCatalogMode(catalogMode);

  if (!vendors.length) return;

  if (currentCountry) {
    try {
      const lastCountry = (localStorage.getItem(COUNTRY_KEY) || '').toUpperCase();
      const lastLanguage = (localStorage.getItem(LANGUAGE_KEY) || '').toLowerCase();
      
      countryChanged = lastCountry !== '' && lastCountry !== currentCountry;
      languageChanged = lastLanguage !== '' && lastLanguage !== currentLanguage;
      
  
      localStorage.setItem(COUNTRY_KEY, currentCountry);
      localStorage.setItem(LANGUAGE_KEY, currentLanguage);
      
  
      if (countryChanged) {
        url.searchParams.delete('autofiltered');
        url.searchParams.delete('filter.p.vendor');
        localStorage.removeItem(FILTERS_KEY);
      }
  
      else if (languageChanged) {
        try {
          const saved = JSON.parse(localStorage.getItem(FILTERS_KEY) || '{}');
      
          if (saved.country === currentCountry && saved.vendors && saved.vendors.length > 0) {
        
            url.searchParams.delete('filter.p.vendor');
            saved.vendors.forEach(v => url.searchParams.append('filter.p.vendor', v));
            url.searchParams.set('autofiltered','1');
            window.location.replace(url);
            return;
          }
        } catch (e) {
      
        }
      }
      
  
  
      const vendorParams = url.searchParams.getAll('filter.p.vendor');
      if (vendorParams.length > 0) {
        localStorage.setItem(FILTERS_KEY, JSON.stringify({ country: currentCountry, vendors: vendorParams }));
      }
    } catch (e) {
    }
  }

  if (url.searchParams.get('autofiltered')) return;

  if (url.searchParams.has('filter.p.vendor')) {
    url.searchParams.set('autofiltered','1');
    window.location.replace(url);
    return;
  }

  vendors.forEach(v => url.searchParams.append('filter.p.vendor', v));
  url.searchParams.set('autofiltered','1');

  window.location.replace(url);

})();
